import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/PaymentSelect.module.scss";

function PaymentRadioButton(
  { paymentMethodId, id, className, children, disabled, ...props },
  ref
) {
  return (
    <div
      className={classnames(styles.paymentInput, {
        [styles.disabled]: disabled,
      })}
    >
      <div className={styles.inner}>
        <input
          ref={ref}
          type="radio"
          name="paymentMethod"
          id={id}
          disabled={disabled}
          {...props}
        />
        <label htmlFor={id} className={className}>
          <span className={styles.check} />
          {children}
        </label>
      </div>
    </div>
  );
}

export default forwardRef(PaymentRadioButton);
